// =============================================================
//  ✏️  EDITA AQUÍ TODO EL CONTENIDO DE LA CARTA
//  Cambia los textos, el nombre, la carta y las fotos.
// =============================================================

export const content = {
  // --- Datos principales ---
  recipientFirst: "EVELYN",
  recipientSecond: "GISELLE",
  fullName: "Evelyn Giselle",
  age: 21,
  sender: "Eduardo Flores",

  // --- Intro / contador de amistad ---
  friendsSince: { year: 2024, month: 3, day: 22 }, // 22 de marzo de 2024
  introKicker: "Antes de revelar de quién es esto…",
  introLine: "Somos amigos desde el 22 de marzo de 2024",
  introSubline: "y no has parado de ser increíble ni un segundo",
  introButton: "Descubre de quién es",

  // --- Hero ---
  heroKicker: "Un regalo hecho solo para ti",
  heroLineTop: "FELIZ 21",

  // --- Sección regalo ---
  giftHint: "Toca para abrir tu sorpresa",
  giftOpened: "¡Sigue bajando, esto apenas empieza!",

  // --- Manifiesto: por qué es especial ---
  manifestoTitle: "Por qué eres tan especial",
  manifesto: [
    {
      n: "01",
      title: "Tu corazón",
      body: "Tienes una forma de cuidar a las personas que hace que todo se sienta más ligero. Eres de esas personas raras y valiosas que hacen bien las cosas sin buscar nada a cambio.",
      color: "bg-butter",
    },
    {
      n: "02",
      title: "Tu risa",
      body: "Contagias alegría sin darte cuenta. Un mal día se arregla contigo cerca, y eso es un súper poder que muy pocos tienen.",
      color: "bg-blush",
    },
    {
      n: "03",
      title: "Tu manera de ser",
      body: "Eres buena, noble y auténtica. Nunca cambies eso. El mundo necesita más gente como tú y yo tengo la suerte de conocerte.",
      color: "bg-sky text-white",
    },
  ],

  // --- Marquee ---
  marqueeText: "CELEBRANDO A EVELYN",
  marqueeSub: "21 AÑOS DE MAGIA",

  // --- Galería (fotos reales) ---
  galleryTitle: "Momentos que valen oro",
  gallery: [
    {
      type: "single",
      caption: "la festejada",
      rotate: "-3deg",
      url: "/photos/evelyn-solo.jpg",
    },
    {
      type: "single",
      caption: "tú y yo",
      rotate: "2deg",
      url: "/photos/mini-selfie.jpg",
    },
    {
      type: "single",
      caption: "los de siempre",
      rotate: "-2deg",
      url: "/photos/mini-group.jpg",
    },
    {
      type: "single",
      caption: "en la feria",
      rotate: "3deg",
      url: "/photos/feria.jpg",
    },
    {
      type: "collage",
      caption: "por más como estos",
      rotate: "-2deg",
      minis: [
        "/photos/mini-evelyn.jpg",
        "/photos/grad.jpg",
        "/photos/candid.jpg",
        "/photos/voli.jpg",
      ],
    },
  ],

  // --- Carta ---
  letterGreeting: "Querida Evelyn,",
  letterParagraphs: [
    "Sé que probablemente esperabas un mensaje normal, pero tú no eres una persona normal, así que merecías algo distinto.",
    "Quería tomarme un momento para decirte lo especial que eres. No solo por tu cumpleaños, sino por todo lo que eres el resto del año: una persona buena, sincera y con un corazón enorme.",
    "Desde que te conozco, aprendí que hay personas que llegan para hacerte la vida más ligera, más divertida y más bonita. Tú eres justamente una de esas personas.",
    "Ver cómo tratas a los demás, cómo sonríes incluso cuando las cosas no salen bien, y cómo haces sentir importantes a las personas que quieres… es algo que admiro muchísimo de ti.",
    "Me gusta cómo te emocionas con las cosas pequeñas, cómo defiendes a los que amas y cómo, aunque a veces dudes de ti misma, siempre terminas demostrando lo fuerte y valiente que eres.",
    "Ojalá pudieras verte como te ven los demás: como esa niña buena, noble y llena de luz que alegra cualquier lugar al que llega. Nunca dejes que nadie apague eso.",
    "Hoy cumples 21 y quiero que sepas que el mundo es un lugar mejor porque tú estás en él. Que este nuevo año te traiga todo lo bonito que tú regalas a los demás, y el doble.",
    "Que se te cumplan los sueños grandes y los chiquitos. Que rías mucho, que te consientan, que viajes, que ames y que nunca te falte gente que te valore como mereces.",
    "Gracias por ser tú. Gracias por ser una tan buena persona. Feliz cumpleaños, Evelyn. Que nunca te falten motivos para reír… y aquí tienes un link entero lleno de ellos.",
  ],
  letterSignoff: "Con mucho cariño,",

  // --- Música de fondo ---
  music: {
    src: "/evelyn-song.mp3",
    title: "If You Love Her",
    artist: "Forest Blakk",
  },

  // --- Sorpresa: globos ---
  balloons: {
    kicker: "Sorpresa #1",
    title: "Revienta los globos",
    subtitle: "Toca cada globo… escondí una palabra que te describe",
    items: [
      { word: "Increíble", color: "#F43F5E" },
      { word: "Divertida", color: "#8B5CF6" },
      { word: "Auténtica", color: "#3B82F6" },
      { word: "Valiente", color: "#FCD34D" },
      { word: "Generosa", color: "#FB7185" },
      { word: "Única", color: "#34D399" },
    ],
    done: "Así eres tú, Evelyn.",
  },

  // --- Sorpresa: pide un deseo ---
  wish: {
    kicker: "Sorpresa #5",
    title: "Pide un deseo",
    subtitle: "Apaga las velitas una por una…",
    done: "¡Que se te cumpla! ¿El mío? Que Dios me permita seguir con tu amistad más años.",
  },

  // --- Sorpresa: tarjetas para voltear ---
  flipReasons: {
    kicker: "Sorpresa #2",
    title: "Motivos para sonreír",
    subtitle: "Voltea cada tarjeta",
    items: [
      { n: "01", reason: "Tu manera de escuchar como si nada más importara." },
      { n: "02", reason: "Cómo te emocionas con las cosas pequeñas." },
      { n: "03", reason: "Tu lealtad con la gente que quieres." },
      { n: "04", reason: "Cómo haces sentir en casa a quien está contigo." },
      { n: "05", reason: "Lo valiente que eres, aunque no lo notes." },
      { n: "06", reason: "Que siempre sacas lo mejor de los demás." },
    ],
  },

  // --- Sorpresa: ábreme cuando ---
  openWhen: {
    kicker: "Sorpresa #4",
    title: "Ábreme cuando…",
    subtitle: "Toca cada sobre para abrirlo",
    items: [
      {
        when: "…tengas un mal día",
        note: "Respira. Eres más fuerte de lo que crees y esto también va a pasar. No estás sola.",
      },
      {
        when: "…quieras sonreír",
        note: "Acuérdate de la última vez que nos reímos sin parar. Eso eres tú: pura alegría.",
      },
      {
        when: "…dudes de ti",
        note: "Lee esto despacio: eres capaz, valiente y más que suficiente. Siempre lo has sido.",
      },
      {
        when: "…quieras celebrarte",
        note: "Hoy y siempre: mereces lo mejor. Baila, ríe y brilla, que para eso naciste.",
      },
    ],
  },

  // --- Sorpresa: voleibol ---
  volleyball: {
    kicker: "Sorpresa #3",
    title: "El voli nos unió",
    subtitle: "Toca el balón y arma el rally",
    rallies: [
      "Todo empezó en una cancha…",
      "un saque, un pase, una risa…",
      "y de repente…",
      "Gracias al voli te conocí, Evelyn.",
    ],
    done: "¡Wepuerka! Ya éramos amigos.",
  },

  // --- Footer ---
  footerCta: "¡FELIZ CUMPLEAÑOS!",
};
